<template>
  <div class="regex-entities">
    <div class="regex-entities__list-item"
      v-for="(item, index1) in entities"
      :key="index1">
      <div class="regex-entities__item-main-container">
        <div class="regex-entities__item-gradient"></div>
        <div class="regex-entities__item-main">
          <dynamic-text class="entities__list-item-name"
            :minWidth="80"
            :inputCustomStyle="{ 'text-align': 'left' }"
            :placeholder="$t('plugins.nlp.entities.regexTable.placeholders.entity')"
            v-model="item.name"
            @changed="entityChanged(index1, $event)"
            />
          <div class="regex-entities__item-filler" @click="toggleEntriesList(index1)"></div>
          <div class="regex-entities__item-end-cont">
            <div class="entities__item-prio-cont"
              @click="prioChanged(item)">
              <div :class="'entities__item-prio-dot entities__item-prio-dot' + getPrioModifierClass(item.priority)">
              </div>
            </div>
            <fai class="regex-entities__item-entry-del"
              icon="ban"
              v-if="index1 !== entities.length-1"
              @click="entityDelete(index1)"
            ></fai>
          </div>
        </div>
      </div>
      <div ref="refRegexes" class="regex-entities__item-regexes"
        :style="[index1 === entities.length-1 ? { visibility: 'visible', position: 'static' } : { visibility: 'hidden', position: 'absolute' }]"
        >
        <div class="regex-entities__item-regex"
          v-for="(regex, index2) in item.entities_regexes"
          :key="index2">
          <div class="regex-entities__item-regex-content">
            <div class="regex-entities__item-exp">
              <dynamic-text
                :ref="'refRegex'+index1+index2"
                class="regex-entities__input-exp"
                :minWidth="60"
                :placeholder="$t('plugins.nlp.entities.regexTable.placeholders.regex')"
                :value="regex.exp"
                @changed="regexChanged(index2, item.entities_regexes, $event);
                  setNextRegexFocus(index1, index2, item.entities_regexes.length)"
                />
            </div>
            <fai class="regex-entities__item-entry-del" 
              icon="ban"
              v-if="index2 !== item.entities_regexes.length-1"
              @click="regexDelete(item, index2)"
            ></fai>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dynText from './DynamicTextarea.vue'
export default {
  data () {
    return {
      entities: null,
      actToDelete: null,
      temps: {
        entityTemp: {
          name: '',
          is_fuzzy: false,
          priority: 0,
          entities_regexes: [
            {
              exp: ''
            }
          ]
        },
        regexTemp: {
          exp: ''
        }
      }
    }
  },

  props: {
    value: Array,
    toDelete: Object
  },

  watch: {
    value: function () {
      this.entities = JSON.parse(JSON.stringify(this.value))
      this.appendNewTemplates()
    }
  },

  mounted () {
    this.entities = JSON.parse(JSON.stringify(this.value))
    this.actToDelete = JSON.parse(JSON.stringify(this.toDelete))
    this.appendNewTemplates()
  },
  methods: {
    //// =============================================================================
    //// data manipulation
    prioChanged(item) {
      if(item.priority<2) item.priority += 1
      else item.priority = 0
      item.edited = true
      this.$emit('input', this.entities)
      this.$store.commit('SET_EDITED', true)
    },

    entityChanged (index, str) {
      if(!str) return
      this.entities[index].name = str
      if(this.entities[index].id) this.entities[index].edited = true
      if(index === this.entities.length-1) {
        for(let i = 0; i<this.entities.length; i++) {
          this.entities[i].entities_regexes.pop()
        }
        this.$emit('input', this.entities)
        //this.entities.push(JSON.parse(JSON.stringify(this.temps.entityTemp)))
      } else {
        this.removeTemplates()
        this.$emit('input', this.entities)
      }
    },

    regexChanged (index, regexes, str) {
      let regex = regexes[index]
      if(!str) return
      regex.exp = str
      if(regex.id !== undefined) regex.edited = true
      if (index === regexes.length-1) {
        regexes.push(JSON.parse(JSON.stringify(this.temps.regexTemp)))
      }
      this.removeTemplates()
      this.$emit('input', this.entities)
    },

    appendNewTemplates () {
      for(let i = 0; i<this.entities.length; i++) {
        this.entities[i].entities_regexes.push(JSON.parse(JSON.stringify(this.temps.regexTemp)))
      }
      this.entities.push(JSON.parse(JSON.stringify(this.temps.entityTemp)))
    },

    //// =============================================================================
    //// crud to save later
    regexDelete (entity, index) {
      let regex = entity.entities_regexes[index]
      if(regex.id) {
        this.actToDelete.regexes.push({ id: regex.id, parent_id: entity.id })
        this.$emit('delChanged', this.actToDelete)
      }
      entity.entities_regexes.splice(index, 1)
      this.removeTemplates()
      this.$emit('input', this.entities)
    },

    entityDelete(index) {
      let entity = this.entities[index]
      if(entity.id) {
        // remove previously deleted children from array
        // as deleting parent in db will take care of them
        for(let i = 0; i<this.actToDelete.regexes.length; i++) {
          if(this.actToDelete.regexes[i].parent_id === entity.id) {
            this.actToDelete.regexes.splice(i, 1)
            i--
          }
        }
        this.actToDelete.entities.push(entity.id)
        this.$emit('delChanged', this.actToDelete)
      }
      this.entities.splice(index, 1)
      this.removeTemplates()
      this.$emit('input', this.entities)
    },
    //// =============================================================================
    //// visibility, misc
    removeTemplates () {
      for(let i = 0; i<this.entities.length; i++) {
        this.entities[i].entities_regexes.pop()
      }
      this.entities.pop()
    },

    setNextRegexFocus (index1, index2, len) {
      if(index2 < len-2) return
      setTimeout(() => {
        this.$refs['refRegex'+index1+''+(index2+1)][0].$el.children[0].focus()
      }, 0)
    },

    toggleEntriesList (index) {
      let elem = this.$refs.refRegexes[index]
      if(elem.style.visibility === 'hidden') {
        elem.style.visibility = 'visible'
        elem.style.position = 'static'
      }
      else {
        elem.style.visibility = 'hidden'
        elem.style.position = 'absolute'
      }
    },

    getPrioModifierClass (value) {
      if(value === 0) return ''
      else if(value === 1) return '--yellow'
      return '--red'
    }
  },

  components: {
    'dynamic-text': dynText
  }
}
</script>

<style lang="scss">
.regex-entities {
   &__list-item {
    margin-bottom: 10px;
  }
  &__item-main-container {
    display: flex;
    width: 100%;
    margin-bottom: 4px;
  }
  &__item-main {
    background-color: white;
    border-radius: 0px 4px 4px 0px;
    padding: 8px 10px;
    display: flex;
    align-items: center;
    flex-grow: 1;
  }
  &__item-gradient {
    background-color: $primary;
    border-radius: 4px 0px 0px 4px;
    width: 4px;
    position: relative;
  }
  &__item-filler {
    cursor: pointer;
    flex-grow: 1;
    height: 100%;
  }
  &__input-name {
    font-size: inherit;
    font-family: inherit;
  }
  &__item-regexes {
  }
  &__item-regex {
    width: 90%;
    background: #f7f7f7;
    padding: 6px;
    margin-bottom: 4px;
    border-radius: 4px;
    display: flex;
    margin-left: 4px;
  }
  &__item-regex-content {
    flex-grow: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__item-exp {
  }
  &__input-exp {
    font-size: 0.8em;
    padding: 4px;
    border: solid 1px;
    border-color: chocolate;
    background: white;
    border-radius: 4px;
  }

  &__item-end-cont {
    width: 20%;
    display: flex;
    justify-content: space-between;
  }

  &__item-entry-del {
    cursor: pointer;
    padding: 4px;
    align-self: center;
  }

  &__item-prio-cont {
    padding: 4px;
  }

  &__item-prio-dot {
    cursor: pointer;
    background: #62A87C;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    transition-property: background-color;
    transition-duration: 0.3s;
    border: solid 1px;
    border-color: #e6e6e6;

    &--yellow {
      background: #FFFC99;
    }

    &--red {
      background: #E28565;
    }
  }
}
</style>